import { render, staticRenderFns } from "./DeductDialog.vue?vue&type=template&id=71880bdd&scoped=true"
import script from "./DeductDialog.vue?vue&type=script&lang=js"
export * from "./DeductDialog.vue?vue&type=script&lang=js"
import style0 from "./DeductDialog.vue?vue&type=style&index=0&id=71880bdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71880bdd",
  null
  
)

export default component.exports